export default "__VITE_ASSET__FxqQcjUn__"